var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-layout",
    style: _vm.colorObject
  }, [_vm.isLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中...",
      "background-color": '#ffffff'
    }
  }) : _vm._e(), _vm.isDisplayingQrcodeScanner ? _c('div', {
    staticClass: "scanner-view"
  }, [_c('div', {
    staticClass: "scanner-view__body"
  }, [_c('div', {
    staticClass: "scanner-view__title mb-3"
  }, [_vm._v("請將 QR code 對準框線")]), _c('QRCodeScanner', {
    ref: "qrScanner",
    staticClass: "scanner-view__scanner",
    attrs: {
      "qrbox": _vm.qrbox
    },
    on: {
      "onScan": _vm.handleQrCodeIsScanned
    }
  }), _c('button', {
    staticClass: "scanner-view__close s-btn s-btn-outline-primary s-btn-xs mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleCloseScannerButtonIsClicked
    }
  }, [_vm._v(" 取消 ")])], 1)]) : _vm._e(), _c('div', {
    staticClass: "s-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "custom-elanco-header"
  }, [_c('span', {
    staticClass: "custom-elanco-header__text"
  }, [_vm._v("Hi " + _vm._s(_vm.deepGet(_vm.user, 'name')))]), _c('a', {
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.header_logo_url', '#')
    }
  }, [_vm.deepGet(_vm.event, 'config.images.header_logo') ? _c('img', {
    staticClass: "custom-elanco-header__image ml-3",
    attrs: {
      "src": _vm.deepGet(_vm.event, 'config.images.header_logo')
    }
  }) : _vm._e()])]), _vm.page === 'redeem' ? _c('div', [_vm.event.config.images ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.event.config.images.redeem_confirm_kv,
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('div', {
    staticClass: "card__info"
  }, [_c('ShopSelection', {
    ref: "shopSelection",
    attrs: {
      "disabled": _vm.isLoading || !_vm.branch_provider || _vm.isOverMaxRedeemCount,
      "branch-provider": _vm.branch_provider || '',
      "show-branch-code": false,
      "placeholder": '請選擇購買地點'
    },
    on: {
      "selected": _vm.handleBranchIsSelected
    },
    model: {
      value: _vm.branch_id,
      callback: function callback($$v) {
        _vm.branch_id = $$v;
      },
      expression: "branch_id"
    }
  }), _vm.otherShopIsSelected ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.otherShopName,
      expression: "otherShopName"
    }],
    staticClass: "mt-1 form-control-input",
    attrs: {
      "type": "text",
      "placeholder": "請輸入購買地點"
    },
    domProps: {
      "value": _vm.otherShopName
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) { return; }
        _vm.otherShopName = $event.target.value;
      }
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "redeem-notes mt-3",
    domProps: {
      "innerHTML": _vm._s(_vm.deepGet(_vm.event, 'config.redeem_notes'))
    }
  }), _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading || !_vm.branch_provider || _vm.isOverMaxRedeemCount
    },
    on: {
      "click": _vm.redeem
    }
  }, [_vm._v(" 確定送出 ")]), !_vm.isLoading && (_vm.isOverMaxRedeemCount || _vm.error_message.length > 0) ? _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goToCard
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.member_center_text', '返回會員專區')) + " ")]) : _vm._e(), !_vm.isLoading && (_vm.isOverMaxRedeemCount || _vm.error_message.length > 0) ? _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs mt-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openScanner
    }
  }, [_vm._v(" " + _vm._s(_vm.deepGet(_vm.event, 'config.re_scan_text', '重新掃描')) + " ")]) : _vm._e()])])]) : _vm._e(), _vm.page === 'redeem_success' ? _c('div', {
    staticClass: "content__success"
  }, [_vm.event.config.images ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.event.config.images.redeem_success,
      "alt": "Elanco"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "py-3 px-4"
  }, [_c('div', {
    staticClass: "text-center py-3 content__success__title"
  }, [_vm._v("恭喜您獲得1顆星星")]), _c('button', {
    staticClass: "s-btn s-btn-outline-primary s-btn-xs",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCard
    }
  }, [_vm._v(" 查看回饋詳情 ")])])]) : _vm._e(), _vm.page === 'card' ? _c('div', {
    staticClass: "content__card d-flex flex-column"
  }, [_c('div', {
    staticClass: "d-flex content__card__header align-items-center py-3 px-4"
  }, [_c('div', {
    staticClass: "flex-fill"
  }, [_c('div', {
    staticClass: "content__card__header__title"
  }, [_vm._v("資格星星數與等級")]), _c('div', {
    staticClass: "content__card__header__level"
  }, [_vm._v(_vm._s(_vm.cardConfig.level))])]), _c('div', {
    staticClass: "content__card__header__avatar"
  }, [_vm.cardConfig.avatar ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/".concat(_vm.cardConfig.avatar)),
      "alt": "Avatar"
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "content__card__rating py-3 px-4 d-flex justify-content-center"
  }, _vm._l(6, function (i) {
    return _c('img', {
      key: i,
      staticClass: "mx-2",
      attrs: {
        "src": require("./images/card-star-".concat(i <= _vm.redeemed_count ? 'enable' : 'disable', ".png"))
      }
    });
  }), 0), _c('div', {
    staticClass: "px-3 py-2"
  }, [_vm.cardConfig.content ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/".concat(_vm.cardConfig.content)),
      "alt": "Content"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "content__card__dog flex-fill p-2",
    style: _vm.cardBgStyle
  }, [_c('div', {
    staticClass: "position-relative"
  }, [_c('img', {
    staticClass: "img-fluid",
    style: {
      marginTop: _vm.redeemed_count > 0 ? '0' : '-65px'
    },
    attrs: {
      "src": require("./images/".concat(_vm.cardConfig.dog)),
      "alt": "Dog"
    }
  }), _c('div', {
    staticClass: "content__card__dog__buttons px-3 py-3"
  }, [!_vm.isAtMaxLevel ? _c('button', {
    staticClass: "btn btn-link my-1 mx-2",
    on: {
      "click": _vm.handleOpenScannerButtonIsClicked
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/card-btn-3.png")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('button', {
    staticClass: "btn btn-link my-1 mx-2",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.goToCouponList
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/card-btn-1.png")
    }
  })]), _c('a', {
    staticClass: "btn btn-link my-1 mx-2",
    attrs: {
      "href": _vm.deepGet(_vm.event, 'config.event_detail_url', '#')
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("./images/card-btn-2.png")
    }
  })])])])])])]) : _vm._e(), _vm.page === 'empty_message' ? _c('div', [_vm._m(0), _c('div', {
    staticClass: "btn"
  }, [_c('button', {
    staticClass: "s-btn s-btn-bg-primary s-btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v(" 返回上一頁 ")])])]) : _vm._e()])])], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card"
  }, [_c('p', {
    staticClass: "alert-message"
  }, [_vm._v(" 網址錯誤，沒有活動代碼或序號 ")])]);
}]

export { render, staticRenderFns }